import React from 'react';
import { Section } from './ui/Section';
export function StorySection() {
  return <Section background="accent" data-id="element-160">
      <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-161">
        <div className="w-full md:w-1/3 flex flex-col items-center" data-id="element-162">
          <div className="w-48 h-48 md:w-64 md:h-64 rounded-full overflow-hidden border-4 border-[#22C55E] shadow-2xl mb-6" data-id="element-163">
            <img src="https://i.ibb.co/twQg5HDR/TJyp-Cdmsoi6-Soz-WJ4-V8-EC-1-min-1.webp
" alt="Fundador Varamax" className="w-full h-full object-cover" data-id="element-164" />
          </div>
          <p className="text-gray-400 font-medium italic" data-id="element-165">
            "Lucas M., Creador de Varamax"
          </p>
        </div>

        <div className="w-full md:w-2/3" data-id="element-166">
          <h2 className="text-2xl md:text-3xl font-bold text-white uppercase mb-6" data-id="element-167">
            DE LA INSEGURIDAD AL DOMINIO:{' '}
            <span className="text-[#22C55E]" data-id="element-168">MI HISTORIA</span>
          </h2>
          <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-169">
            <p data-id="element-170">
              "Hace 5 años, estaba exactamente donde tú estás ahora. Frustrado,
              inseguro y sintiendo que algo me faltaba. Probé todo lo que había
              en el mercado: pastillas azules, bombas, ejercicios extraños...
              nada funcionaba a largo plazo."
            </p>
            <p data-id="element-171">
              "Mi relación estaba en la cuerda floja y mi autoestima por los
              suelos. Fue entonces cuando decidí investigar por mi cuenta.
              Viajé, consulté con expertos en urología natural y descubrí la
              combinación exacta de nutrientes que el cuerpo masculino necesita
              para reactivarse."
            </p>
            <p data-id="element-172">
              "Varamax no es solo un producto, es la solución que yo mismo
              necesitaba. Hoy, miles de hombres han recuperado su poder gracias
              a este descubrimiento. Y tú eres el siguiente."
            </p>
          </div>
        </div>
      </div>
    </Section>;
}